// extracted by mini-css-extract-plugin
export default {"loaderBox":"LoadingSpinner_loaderBox__Hha0T","spinner":"LoadingSpinner_spinner__mb-48","spin":"LoadingSpinner_spin__6xqWb","text":"LoadingSpinner_text__Cr0oX"};